var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSeparator = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 2,
  height: 15,
  viewBox: "0 0 2 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.6084 0.958496V14.4429H0.264648V0.958496H1.6084Z",
  fill: "black"
})));
export default SvgSeparator;